import React from "react";

export default function ThanksPage() {
    return (
        <main className="min-h-screen bg-[#0A0E14] text-light flex items-center justify-center px-4">
            <div className="max-w-lg w-full text-center border border-dark-100 rounded-3xl bg-gradient-to-br from-[#0A0E14] via-[#121826] to-[#0A0E14] p-8 sm:p-10 shadow-2xl">
                <h1 className="text-3xl sm:text-4xl font-semibold mb-4">
                    Grazie per averci contattato 🙌
                </h1>
                <p className="text-gray-400 text-lg">
                    Abbiamo ricevuto la tua richiesta e ti risponderemo via email il prima possibile.
                </p>
            </div>
        </main>
    );
}
